export default __webpack_public_path__ + "static/media/Kiunalla5.bbeb7fb4.jpg";